import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-report-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="show" class="report-loader-overlay">
      <div class="report-loader-modal">
        <div class="report-loader-content">
          <div class="report-loader-animation">
            <img [src]="'assets/icons/report-loader.svg'" alt="Report Loader" class="report-loader-svg">
          </div>
          <div class="report-loader-messages">
            <p *ngFor="let message of loadingMessage" class="report-loader-message">{{ message }}</p>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .report-loader-overlay {
      position: fixed;
      top: 80px;
      left: 0;
      width: 100%;
      height: calc(100vh - 80px);
      background: rgba(0, 0, 0, 0.5);
      z-index: 1000;
      pointer-events: auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .report-loader-modal {
      position: relative;
      background: white;
      width: 88.5vw;
      box-shadow: 0px 1px 40px 0px rgba(0, 0, 0, 0.2);
      border-radius: 8px 8px 0px 0px;
      height: calc(90vh + 55px);
      overflow: hidden;
    }

    .report-loader-content {
      padding: 40px 24px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      background: white;
    }
    .report-loader-animation {
      margin-bottom: 20px;
    }
    .report-loader-svg {
      width: 91px;
      height: 39px;
    }
    .report-loader-message {
      color: var(--background-variant-7343536, #343536) !important;
      text-align: center;

      /* Body/Body - Regular - 14|24 */
      font-family: var(--Typeface-Family-Body, Lexend);
      font-size: var(--Typeface-Font-size-sm, 14px);
      font-style: normal;
      font-weight: 400;
      line-height: var(--Typeface-Line-height-24, 24px); /* 171.429% */
      letter-spacing: var(--Typeface-Letter-spacing-4min, -0.16px);
    }
  `]
})
export class ReportLoaderComponent {
  @Input() type: 'customer-report' | 'pdf-download' = 'customer-report';
  @Input() show: boolean = false;

  get loaderTitle(): string {
    return this.type === 'customer-report' ? 'Customer Report' : 'Report Generation';
  }

  get loadingMessage(): string[] {
    return ['Almost there!', 'Preparing your report for preview. Please wait a moment.'];
  }
}
